import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {

  page:any;
  url:string;

  news:any;

  constructor(public api: ApiService, public route: ActivatedRoute) { }

  ngOnInit() {

    this.route.params.subscribe(params=>{
      if(params['id']){
        if(params['id'] == '152'){
          this.api.goTo('preorders-essen');
          return false
        }

        this.url = "https://blackrockgames.fr"+window.location.pathname;
        this.api.post("SPDO=select",{database:'page',where:"id_page = '"+params['id']+"' OR url_rewrite = '"+params['id']+"'"}).then((res:any)=>{
          this.page = res.data[0];
          let elem = document.createElement('div');
          elem.style.display = 'none';
          document.body.appendChild(elem);
          elem.innerHTML = this.page.content;
          if(elem.querySelector('img'))
            this.page.img = elem.querySelector('img').src;
          this.page.text = elem.innerText.substring(0,100)+'...';
        });
        return false;
      }else{
        this.api.post("site=getNewsPage",{page:1,nb_items:10}).then(res=>{
          this.news = res['data'];
          this.api.getJson("https://wordpress.blackrockgames.fr/wp-json/wp/v2/posts?categories=7&_embed").then((res2:any)=>{
            for(let row of res2){
              let item = {
                from: 'wp',
                img:row._embedded['wp:featuredmedia'] ? row._embedded['wp:featuredmedia']['0'].source_url: '',
                date_add: row.date,
                slug: row.slug,
                title: row.title.rendered
              }
              this.news = [...this.news, item];
            }
            this.news = this.news.sort((a,b)=> b.date_add.localeCompare(a.date_add));
            console.log(this.news);
          });
        });
        return false;
      }
    });

    
  }
}
